import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import { keyErrorsFieldRequired } from 'utils/helpers';

const propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  text: PropTypes.any,
  warning: PropTypes.any,
  disabled: PropTypes.bool,
  isErrorVisible: PropTypes.bool,
  mixins: PropTypes.string,
};

const defaultProps = {
  meta: {},
};

const CheckboxInput = (props) => {
  const {
    input,
    meta: { touched, error },
    text,
    disabled,
    mixins,
    warning,
    isErrorVisible,
    ...rest
  } = props;
  const inputClasses = cx({
    checkbox: true,
    'checkbox--state-error': touched && error,
  }, mixins);
  const isErrorTriggered = touched && error
    && error !== keyErrorsFieldRequired && isErrorVisible;

  return (
    <label className={inputClasses}>
      <input
        {...rest}
        {...input}
        type="checkbox"
        className="checkbox__input"
        value={input.value}
        checked={input.value}
        disabled={disabled}
      />
      <span className="checkbox__icon" />
      <span className="checkbox__text">
        {text}
      </span>
      {input.value === false && warning
        && (
        <span className="checkbox__warning">
          {warning}
        </span>
        )}
      {isErrorTriggered
        && (
        <span className="checkbox__warning">
          <FormattedMessage id={error} />
        </span>
        )}
    </label>
  );
};

CheckboxInput.propTypes = propTypes;
CheckboxInput.defaultProps = defaultProps;

export default CheckboxInput;
